import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import classNames from 'classnames';

import type { TextFieldType } from '../Fields/TextField/type';

import { ErrorMessage } from '../ErrorMessage';

export interface ReadOnlyFieldProps {
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  errors?: string | string[];
  label: React.ReactNode;
  type?: TextFieldType;
  fullWidth?: boolean;
  multiline?: boolean;
  className?: string;
  value: string;
}

export const ReadOnlyField = ({
  className,
  endAdornment,
  errors,
  fullWidth,
  label,
  multiline,
  startAdornment,
  type,
  value,
}: ReadOnlyFieldProps) => {
  return (
    <div
      className={classNames(
        'pl-0 pr-0 my-0',
        { 'w-full': fullWidth },
        className,
      )}
    >
      <div className="flex items-center gap-2 py-2 px-0">
        {startAdornment && (
          <span className="relative left-1 right-2">{startAdornment}</span>
        )}
        {label && (
          <Typography color="text.secondary" fontWeight={600} variant="body2">
            {label}
          </Typography>
        )}
        {endAdornment && <span className="relative">{endAdornment}</span>}
      </div>
      {type === 'url' && value ? (
        <Link
          rel="noopener noreferrer"
          className="underline"
          target="_blank"
          href={value}
        >
          {value}
        </Link>
      ) : (
        <Typography
          className={classNames(
            'overflow-hidden text-ellipsis',
            multiline ? 'whitespace-pre-line' : 'whitespace-nowrap',
          )}
          color="text.primary"
          variant="body2"
        >
          {value || '-'}
        </Typography>
      )}

      {errors && <ErrorMessage className="mt-1" errors={errors} />}
    </div>
  );
};

export default ReadOnlyField;
